export function truncateTo100Words(content) {
    const wordsArray = content?.split(" ");
    if (wordsArray?.length > 100) {
      return wordsArray?.slice(0, 75).join(" ") + "...."; //truncate to 80 words
    }
    return content;
  }